module.exports = __webpack_public_path__ + "contact-small.png?0c189b94c4157371a87840e4a0756655";